import { type CustomTooltipProps } from "ag-grid-react"

import { leafVariantIds } from "~/components/planning/ProductTable/columns/cellHelpers"
import { useFlags } from "~/features/feature-flags"

import HeaderTooltip from "./HeaderTooltip"
import PreorderFulfillmentCard from "../../cards/PreorderFulfillmentCard"

export default function PreordersTooltip(props: CustomTooltipProps) {
  const { unfulfillablePreorders: unfulfillablePreordersFlag } = useFlags()

  if (props.location === "header") {
    return <HeaderTooltip {...props} />
  }

  if (!unfulfillablePreordersFlag) return null

  const variantIds = props.node?.group ? leafVariantIds(props) : [props.data.variantId]
  // Variant rows carry `skuIds` (array); SKU leaf rows carry a single `skuId` string.
  const skuIds = props.node?.group
    ? undefined
    : (props.data.skuIds ?? (typeof props.data.skuId === "string" ? [props.data.skuId] : undefined))

  if (!variantIds || variantIds.length === 0) return null
  return <PreorderFulfillmentCard variantIds={variantIds} skuIds={skuIds} />
}
